module.exports = __webpack_public_path__ + "image/city_map_1_c5b05.png";